var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLpTokenActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 8.40625V10.7187C11.5625 12.6687 9.74375 14.25 7.5 14.25C5.25625 14.25 3.4375 12.6687 3.4375 10.7187V8.40625C3.4375 10.3562 5.25625 11.75 7.5 11.75C9.74375 11.75 11.5625 10.3562 11.5625 8.40625Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 5.28125C11.5625 5.85 11.4062 6.375 11.1312 6.825C10.4625 7.925 9.0875 8.625 7.5 8.625C5.9125 8.625 4.5375 7.925 3.86875 6.825C3.59375 6.375 3.4375 5.85 3.4375 5.28125C3.4375 4.30625 3.89375 3.425 4.625 2.7875C5.3625 2.14375 6.375 1.75 7.5 1.75C8.625 1.75 9.6375 2.14375 10.375 2.78125C11.1063 3.425 11.5625 4.30625 11.5625 5.28125Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 5.28125V8.40625C11.5625 10.3563 9.74375 11.75 7.5 11.75C5.25625 11.75 3.4375 10.3563 3.4375 8.40625V5.28125C3.4375 3.33125 5.25625 1.75 7.5 1.75C8.625 1.75 9.6375 2.14375 10.375 2.78125C11.1063 3.425 11.5625 4.30625 11.5625 5.28125Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpTokenActive);
export default __webpack_public_path__ + "static/media/lp-token-active.06369d24766c23e21503d37d59f25c82.svg";
export { ForwardRef as ReactComponent };